import { ServiceType } from "@agroyaar/sdk";
import { dividerColor } from "../../utils/report-color";

interface DividerProps {
  serviceType: ServiceType;
}

const Divider = ({ serviceType }: DividerProps) => {
  const dividerBackground = dividerColor(serviceType);

  return (
    <div
      className="w-[95%] h-[2px] my-4 rounded-[20px]"
      style={{
        background: dividerBackground,
        backdropFilter: "blur(20px)",
        boxShadow: "0px 2px 8px rgba(133, 133, 133, 0.25)",
      }}
    ></div>
  );
};

export default Divider;
